import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVolumeMinimum: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase
      {...props}
      ariaLabel="volume-minimum, speaker, loud, sound"
    >
      <path
        d="M14.8284 9.17157C15.5523 9.89543 16 10.8954 16 12C16 13.1046 15.5523 14.1046 14.8284 14.8284M2 8H6L12 4.75V19.25L6 16H2V8Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </CentralIconBase>
  );
};

export default IconVolumeMinimum;
